export default {
  NavigationLink: 'navigation link',
  Link: 'external url',
  File: 'file',
  Infox: 'infox',
};
